import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'
import { useWiFiModel } from './../model'
import { ButtonClose } from '@shared/ui'
import { useThemeModel } from '@entities/theme'


export default /*#__PURE__*/_defineComponent({
  __name: 'WiFiModal',
  setup(__props) {

const copiedText = ref<boolean>(false)

const wifiModel = useWiFiModel()

const themeModel = useThemeModel()

const onCopyClick = () => {
  navigator.clipboard.writeText(wifiModel.data?.password)
  copiedText.value = true
  setTimeout(() => { copiedText.value = false }, 1000)
}

const closeModal = () => {
  wifiModel.modal = false
}

return { __sfc: true,copiedText, wifiModel, themeModel, onCopyClick, closeModal, ButtonClose }
}

})